<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><b>ACKNOWLEDGEMENTS</b></p>
<p class="noindent">The author would like to thank the following for their kind assistance: Hannah Cassilly at The History Press, Hillary Kativa at the Historical Society of Pennsylvania, Margery Sly at Temple University Urban Archives, Jonathan Stayer at Pennsylvania State Archives, James Bostick, Dave Brown, Josh Morris, Bill Montgomery, Luke Papa, Ed Straddling, Gary Heller and my mother, Susan Webster (Philly’s best teacher). And a special thanks to all the Byberrians—you know who you are.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?1a9fb8b6